import css from 'styled-jsx/css';

import { gradient } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .BoUserChallengePage {
    &__back-to {
      font-size: 13px;
      line-height: 18px;
      color: #777777;
      margin: -14px 0 0 0;
      padding: 10px 0 10px 14px;
      position: relative;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }

      &:before {
        content: '';
        width: 10px;
        height: 1px;
        background: #777777;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    &-info {
      box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.06);
      padding: rem(25px 60px 25px 30px);
      margin-bottom: rem(20px);
      position: relative;

      @include respond-to(sm) {
        padding: rem(20px 15px 20px);
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
      }
    }

    &__top-info-list {
      display: grid !important;
      grid-template-columns: repeat(auto-fit, minmax(min-content, 180px));
      justify-content: space-between;
      row-gap: 20px;
      column-gap: 10px;

      @include respond-to(sm) {
        display: block !important;
      }

      @media (min-width: 878px) {
        grid-template-columns: repeat(4, minmax(min-content, 180px));
      }

      @media (min-width: 1200px) {
        grid-template-columns: repeat(5, minmax(min-content, 180px));
      }

      @media (min-width: 1667px) {
        grid-template-columns: repeat(6, minmax(min-content, 180px));
      }
    }

    &__top-info-item {
      margin: 0 !important;
      padding: 0 !important;

      @include respond-to(sm) {
        display: flex;
        align-items: center;
        margin-bottom: 7px !important;
      }

      > span {
        display: block;
        margin-bottom: 5px;
        font-size: rem(13px);

        @include respond-to(sm) {
          width: 40%;
          margin: 0 10px 0 0 !important;
        }
      }

      > div {
        font-size: rem(15px);

        @include respond-to(sm) {
          width: 60%;
          font-size: rem(13px);
          word-break: break-word;
        }
      }
    }

    &__buttons-inner {
      display: flex;
      gap: 30px;

      @include respond-to(sm) {
        gap: 15px;
      }

      button {
        margin-top: 25px;

        @include respond-to(sm) {
          width: calc(50% - 8px);
          margin-top: 20px;
        }
      }
    }

    &__increase-modal-buttons {
      display: flex;
      justify-content: space-around;
      padding-top: 20px;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .BoUserChallengePage {
      &-info {
        background-color: ${colors.white.hex};

        &:after {
          background: ${gradient(90, [colors.gradientStart.rgb, 1], 0, [colors.gradientEnd.rgb, 1], 100)};
        }
      }

      &__top-info-item {
        > span {
          color: ${colors.gray.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
